import { default as _91slug_93iFKM4ikQXdMeta } from "/opt/build/repo/pages/development/[slug].vue?macro=true";
import { default as indexUB3ImECHPuMeta } from "/opt/build/repo/pages/development/index.vue?macro=true";
import { default as _91slug_9373wMt6FslBMeta } from "/opt/build/repo/pages/development/projects/[slug].vue?macro=true";
import { default as component_45stubRU5sOBTecHMeta } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubRU5sOBTecH } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "slug___en",
    path: "/:slug()",
    meta: _91slug_93iFKM4ikQXdMeta || {},
    component: () => import("/opt/build/repo/pages/development/[slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___nl",
    path: "/nl/:slug()",
    meta: _91slug_93iFKM4ikQXdMeta || {},
    component: () => import("/opt/build/repo/pages/development/[slug].vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/",
    meta: indexUB3ImECHPuMeta || {},
    component: () => import("/opt/build/repo/pages/development/index.vue").then(m => m.default || m)
  },
  {
    name: "index___nl",
    path: "/nl",
    meta: indexUB3ImECHPuMeta || {},
    component: () => import("/opt/build/repo/pages/development/index.vue").then(m => m.default || m)
  },
  {
    name: "projects-slug___en",
    path: "/projects/:slug()",
    meta: _91slug_9373wMt6FslBMeta || {},
    component: () => import("/opt/build/repo/pages/development/projects/[slug].vue").then(m => m.default || m)
  },
  {
    name: "projects-slug___nl",
    path: "/nl/projects/:slug()",
    meta: _91slug_9373wMt6FslBMeta || {},
    component: () => import("/opt/build/repo/pages/development/projects/[slug].vue").then(m => m.default || m)
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/en",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/team",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/about-us",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/our-projects",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/team/bastiaan-bor",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/team/bjorn-konink",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/team/matthijs-de-haan",
    component: component_45stubRU5sOBTecH
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubRU5sOBTecH
  }
]